
import { Component, Vue } from 'vue-property-decorator';

import RegistrationForm from '../RegistrationForm.vue';

import Meanderer from 'meanderer';

@Component({
  components: {
    RegistrationForm,
  },
})
export default class App extends Vue {
  readonly PATH_ROCKET1 =
    'M1761.63,1644.59c0-422.69-381.65-2831.18-440.26-2831.18';

  readonly PATH_ROCKET2 = 'M-731.67,378.5,2916.77,620.22';

  readonly PATH_ASTEROID =
    'M2652-1210.57Q1443.38-117.89,359.66,1260.72q-208,264.58-411.37,539.7';

  readonly WIDTH = 1920;
  readonly HEIGHT = 1080;

  pathRocket1 = this.PATH_ROCKET1;
  pathRocket2 = this.PATH_ROCKET2;
  pathAsteroid = this.PATH_ASTEROID;

  mounted() {
    const responsivePath = new Meanderer({
      path: this.PATH_ROCKET1,
      width: this.WIDTH,
      height: this.HEIGHT,
    });

    const responsivePath2 = new Meanderer({
      path: this.PATH_ASTEROID,
      width: this.WIDTH,
      height: this.HEIGHT,
    });

    const responsivePath3 = new Meanderer({
      path: this.PATH_ROCKET2,
      width: this.WIDTH,
      height: this.HEIGHT,
    });

    const setPath = () => {
      this.pathRocket1 =
        '"' +
        responsivePath.generatePath(window.innerWidth, window.innerHeight) +
        '"';

      this.pathAsteroid =
        '"' +
        responsivePath2.generatePath(window.innerWidth, window.innerHeight) +
        '"';

      this.pathRocket2 =
        '"' +
        responsivePath3.generatePath(window.innerWidth, window.innerHeight) +
        '"';
    };

    setPath();

    window.addEventListener('resize', function () {
      setPath();
    });
  }
}
